module.exports = __webpack_public_path__ + "static/media/trainsara.f6cb3e69.gif";